<template>

  <v-container
    v-if="user && roles"
    :style="{width: '100%', maxWidth: '960px'}"
    ref="parent"
    fluid
  >

    <v-card outlined class="ma-2" style="margin-bottom: 58px !important;">
      <v-card-title>Utilizator</v-card-title>

      <v-divider class="mx-4"/>

      <v-card-text>
        <v-row no-gutters>

          <v-col cols="12">
            <v-list-item class="pa-0 ma-1 mt-n2">
              <v-list-item-avatar>
                <v-img v-if="query_profile.avatar" :src="query_profile.avatar"/>
                <v-icon v-else x-large v-html="`mdi-account-circle`"/>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-html="query_profile.full_name"/>
                <v-list-item-subtitle v-html="query_profile.email"/>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col cols="12">
            <v-autocomplete v-model="user.roles" :items="roles" class="ma-1" label="Roluri" multiple outlined hide-details dense>
              <template v-slot:selection="data">
                <v-chip v-bind="data.attrs" :input-value="data.selected" @click:close="onRoleRemoved(data.item)" close small>
                  {{data.item.text}}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>

        </v-row>
      </v-card-text>

    </v-card>

    <v-card outlined v-resize="onResize" :width="dynamic_width" class="ma-2" :style="{position: 'fixed', bottom: 0, maxWidth: '960px'}">
      <v-card-actions>
        <v-spacer/>
        <v-btn depressed color="primary white--text" @click="save" :loading="saving" :disabled="saving">
          <v-icon left>mdi-floppy</v-icon>
          Salvează
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import profiles_repository from "@/repositories/profile-repository";
  import roles_repository from "@/repositories/roles-repository";

  export default {

    data: () => ({
      user_profile: null,
      query_profile: null,
      user: null,
      roles: null,

      saving: false,

      dynamic_width: 0
    }),

    async created() {

      this.user_profile = await profiles_repository.getMyProfile();
      this.query_profile = await profiles_repository.getProfile(this.$route.params.user, this.user_profile);

      if (this.query_profile) {
        roles_repository.getUserRoles(this.query_profile).then(r => this.user = r);
        roles_repository.getRoles(null, {page: 1, size: Number.MAX_SAFE_INTEGER}, {dropdown: true}).then(r => this.roles = r);
      } else {
        await this.$store.dispatch('alert/error', 'Nu ai access la acest utilizator.');
        await this.$router.push('/admin/users');
      }

    },

    methods: {

      async save() {
        try {
          this.saving = true;
          await roles_repository.saveUserRoles(this.query_profile.user_id, this.user.roles);
          this.user = await roles_repository.getUserRoles(this.query_profile);
          await this.$store.dispatch('alert/success', 'Utilizatorul a fost salvat.');
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.saving = false
        }
      },

      onRoleRemoved(role) {
        const index = this.user.roles.indexOf(role.value);
        if (index >= 0) this.user.roles.splice(index, 1)
      },

      onResize() {
        this.dynamic_width = this.$refs['parent'].clientWidth - 40;
      }
    }

  }
</script>